module.exports = __webpack_public_path__ + "static/media/the-saleroom-com_logo.9545b189.png";